var _path, _rect, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoardImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 384,
    viewBox: "0 0 660 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H650V374H10V10Z",
    fill: "#EFDFCF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 8,
    height: 384,
    rx: 4,
    fill: "#513A2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 20,
    height: 374,
    rx: 4,
    fill: "url(#paint0_linear_1363_14310)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 646,
    width: 8,
    height: 384,
    rx: 4,
    fill: "#513A2A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 379,
    width: 20,
    height: 374,
    rx: 4,
    transform: "rotate(180 660 379)",
    fill: "url(#paint1_linear_1363_14310)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1363_14310",
    x1: 4.03392e-7,
    y1: 184.373,
    x2: 20,
    y2: 184.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEB499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9165"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1363_14310",
    x1: 660,
    y1: 558.373,
    x2: 680,
    y2: 558.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEB499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F866C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardImg2);
export default __webpack_public_path__ + "static/media/board_img_2.5e456f3cd8311d2f31ed37a978645fc0.svg";
export { ForwardRef as ReactComponent };